import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import {useCookies} from "react-cookie";
import axios from "axios";
import {ClientSessionReadOnly} from "../client/ClientSessionReadOnly";
import * as ga from "../../lib/gtag";

export const TrackingView = (props: { trackingId: string }) => {


    const [cookies, setCookie] = useCookies(['qme_customer']);

    const [error, setError] = useState(null)
    const [name, setName] = useState(null)
    const [tokenNumber, setTokenNumber] = useState(null)
    const [waitingAhead, setWaitingAhead] = useState(0)
    const [currentTokenNumber, setCurrentTokenNumber] = useState(null)
    const [businessName, setBusinessName] = useState(null)
    const [clientName, setClientName] = useState(null)
    const [clientQr, setClientQr] = useState(null)
    const [clientStatus, setClientStatus] = useState("inactive")
    const [waitingTime, setWaitingTime] = useState(null)
    const [consultDate, setConsultDate] = useState(null)
    const [sessionDisplay, setSessionDisplay] = useState(null)
    const [consultationTime, setconsultationTime] = useState(null)
    const [isForToday, setIsForToday] = useState(null)

    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if (props.trackingId) {
            handleRequest()
        }
    }, [props.trackingId]);


    const handleRequest = () => {
        setLoading(true)
        axios.get('/api/backend/queue/customer/track?t=' + props.trackingId.replace(",", ""))
            .then(resp => {
                if (resp.data) {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data.status != "expired") {
                        setTokenNumber(resp.data.token)
                        setName(resp.data.name)
                        setCurrentTokenNumber(resp.data.currentToken)
                        setWaitingTime(resp.data.estimatedWaitingTime)
                        setWaitingAhead(resp.data.waitingAhead)
                        setBusinessName(resp.data.businessName)
                        setClientName(resp.data.clientName)
                        setClientStatus(resp.data.clientStatus)
                        setClientQr(resp.data.qrCode)
                        setconsultationTime(resp.data.consultationTimeRange)
                        setConsultDate(resp.data.consultDate)
                        setSessionDisplay(resp.data.sessionDisplay)
                        setIsForToday(resp.data.forToday)

                        ga.event({
                            action: "status_track",
                            params: {
                                trackingId: props.trackingId,
                                client_qr: clientQr
                            }
                        });
                    } else {
                        setError("Tracking URL is expired")
                    }
                } else {
                    setError("* Something went wrong")
                }
            })
            .catch(err => {
                setError("* Something went wrong")
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            })
            .finally(() => {
                setLoading(false)
            })
    };

    function getDoctorStatus() {
        return <>
            {clientStatus != "active" &&
                <>
                    <div className="text-secondary fs-5 pb-4 fw-semibold">&#128308;&nbsp; Doctor hasn&apos;t
                        arrived yet.
                    </div>
                </>
            }

            {clientStatus == "active" &&
                <div className="text-secondary fs-5  pb-4 fw-semibold">&#128994;&nbsp; Doctor is attending to the patients.
                </div>
            }
        </>;
    }

    function getTrackingView() {
        return <>
            {tokenNumber && tokenNumber != currentTokenNumber &&
                <div>
                    <h2 className="text-info">{businessName}</h2>
                    <div className="col col-12 pt-4 pb-2 fs-5 text-left">
                        <div className="d-flex gap-1">
                            <div className="text-muted">Doctor:</div>
                            <div className="text-info">{clientName}</div>
                        </div>
                    </div>
                    {isForToday &&
                        <>
                            {getDoctorStatus()}
                        </>
                    }
                    <div className="py-2">
                        <div className="d-flex gap-1">
                            <div className="text-muted fs-5">Patient Name:&nbsp;&nbsp;</div>
                            <div className="fs-5">{name}</div>
                        </div>
                    </div>
                    <div className="py-1">
                        <div className="d-flex gap-1">
                            <div className="text-muted fs-5"> Token:&nbsp;&nbsp;</div>
                            <div className="fs-5">{tokenNumber}</div>
                        </div>
                    </div>
                    <div className="py-2">
                        <div className="d-flex gap-1">
                            <div className="text-muted fs-5">Patients Ahead:&nbsp;&nbsp;</div>
                            <div className="fs-5">{waitingAhead}</div>
                        </div>
                    </div>
                    {!isForToday &&
                        <>
                            <div className="py-2">
                                <div className="d-flex gap-1">
                                    <div className="text-muted fs-5">Appointment Date:&nbsp;&nbsp;</div>
                                    <div className="fs-5">{consultDate}</div>
                                </div>
                            </div>

                        </>
                    }

                    {sessionDisplay && <div className="py-2">
                            <div className="text-muted fs-5 d-inline-block">Session Timing:&nbsp;&nbsp;</div>
                            <div className="fs-5 d-inline-block">{sessionDisplay}</div>
                    </div>}

                    <div className="py-4">
                        <div className="text-muted fs-5 d-inline-block">Estimated Consultation Time Between:&nbsp;&nbsp;</div>
                        <div className="fs-3 d-inline-block text-success">{consultationTime}</div>


                        <div className="pt-3 text-danger ">
                            <div className="card p-3">* This is indicative time only and is NOT A GUARANTEE.<br/>* Please reach 15 minutes prior to your indicative time.</div>
                        </div>
                    </div>

                    <div className="py-3">
                        <button className="btn btn-info text-white" type="button"
                                onClick={handleRequest}
                                disabled={props.trackingId == null}> &#8634; Refresh
                        </button>
                    </div>
                </div>
            }
            {tokenNumber && tokenNumber == currentTokenNumber &&
                <div>
                    <div className="py-3 fs-3 text-warning">Hey {name}</div>
                    <div className="fs-1 bg-success text-light p-4">It&apos;s time. Please proceed to
                        the doctor.
                    </div>
                    <div className="fs-6 text-black pt-3 mt-3">
                        Visit <a href="https://qme.co.in">www.qme.co.in</a> for online appointment next time
                    </div>
                </div>
            }
            {error &&
                <div>
                    <div className="my-3 text-danger fs-3">{error}</div>
                    <div className="fs-6 text-black pt-3 mt-3">
                        For taking appointment again, please visit <a href="https://qme.co.in">www.qme.co.in</a>
                    </div>
                </div>
            }
        </>;
    }

    return (
        <>
            {!loading &&
                <div className="row">
                    <div className="col col-md-6 offset-md-3 col-lg-6 offset-lg-3 d-grid pt-5">
                        <div className="card py-lg-5 px-3 px-lg-5 shadow-lg d-none d-md-block">
                            {getTrackingView()}
                        </div>
                        <div className="px-3 d-md-none">
                            {getTrackingView()}
                        </div>
                    </div>
                </div>
            }
            {loading &&
                <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
        </>
    );
};
